export default {
  MAX_PAGE_SIZE: 99999999 // Use it if you want to fetch all items (we are assuming that overall number of items is smaller than this value)
};